import swal from 'sweetalert2'
import router from 'src/router'
import { API } from 'src/services'
import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'
import i18n from 'src/typescript/servicos/i18n/i18n.servico'
import {
  dividirEmLotes,
  obterIdDoPerfilDoUsuario,
  obterUsuariosParaSincronizarComBloqueioPorPerfil
} from './perfilDoUsuario'

import {
  vuexMapDefaultsMutations
} from 'src/utils.store'

const retonarTipoDeInfoAfetada = tipoDeInfoAfetada => {
  const tiposDeInfo = {
    'empregado': {id: 'empregado', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.empregados')},
    'regra_de_calculo': {id: 'regra_de_calculo', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.regraDeCalculo')},
    'local_de_trabalho': {id: 'local_de_trabalho', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.localDeTrabalho')}
  }
  return tiposDeInfo[tipoDeInfoAfetada]
}

const retornarTipoDeGatilho = tipoDeGatilho => {
  const tiposDeGatilho = {
    'dias_corridos': {id: 'dias_corridos', name: i18n.t('lockerRules.details.State.tipoGatilho.dia')},
    'evento_travamento': {id: 'evento_travamento', name: i18n.t('lockerRules.details.State.tipoGatilho.travamentoIniciado')}
  }
  return tiposDeGatilho[tipoDeGatilho]
}

const retornarMensagemDeErro = (erro, mensagemPadrao) => {
  if (erro?.data?.error) {
    return erro.data.error
  }
  if (!mensagemPadrao) {
    return i18n.t('lockerRules.comuns.mensagemErroComum')
  }
  return mensagemPadrao
}

const formatarListasParaRequisicao = listaDeObjetos => {
  let selecionados = listaDeObjetos.selected
  if (!selecionados) return null
  return listaDeObjetos.selected.map(obj => obj.id)
}

const formatarObjetoParaRequisicao = state => {
  let tipoDeGatilho = state.tipoDeGatilho.selected.id
  let diaDoFechamento = state.diaDoFechamento

  if (tipoDeGatilho === 'evento_travamento') {
    diaDoFechamento = null
  }

  return {
    nome: state.nome,
    codigo: state.codigo,
    ativo: state.ativo,
    tipo_de_info_afetada: state.tipoDeInfoAfetada.selected.id,
    ids_afetados: formatarListasParaRequisicao(state.idsAfetados),
    tipo_de_gatilho: tipoDeGatilho,
    dias_de_tolerancia: state.diasDeTolerancia,
    tem_prazo_de_travamento: state.temPrazoDeTravamento,
    confirmar_automaticamente: state.confirmarAutomaticamente,
    dia_do_fechamento: diaDoFechamento,
    perfis_responsaveis: formatarListasParaRequisicao(state.perfisResponsaveis),
    tipo_de_evento_de_travamento: state.tipoDeEventoDeTravamento
  }
}

const formatarObjetoParaGuardarNoState = regraDeTravamento => {
  return {
    id: regraDeTravamento.id,
    nome: regraDeTravamento.nome,
    ativo: regraDeTravamento.ativo,
    codigo: regraDeTravamento.codigo,
    tipoDeGatilho: regraDeTravamento.tipo_de_gatilho,
    tipoDeInfoAfetada: regraDeTravamento.configuracao_de_aplicacao_da_regra.tipo_de_info_afetada,
    idsAfetados: regraDeTravamento.configuracao_de_aplicacao_da_regra.ids_afetados,
    diasDeTolerancia: regraDeTravamento.configuracao_de_gatilho.dias_de_tolerancia,
    temPrazoDeTravamento: regraDeTravamento.configuracao_de_gatilho.tem_prazo_de_travamento,
    confirmarAutomaticamente: regraDeTravamento.configuracao_de_gatilho.confirmar_automaticamente,
    diaDoFechamento: regraDeTravamento.configuracao_de_gatilho.dia_do_fechamento,
    perfisResponsaveis: regraDeTravamento.configuracao_de_gatilho.perfis_responsaveis,
    tipoDeEventoDeTravamento: regraDeTravamento.configuracao_de_gatilho.tipo_de_evento_de_travamento
  }
}

const defaultState = () => {
  return {
    id: null,
    ativo: true,
    nome: '',
    codigo: '',
    tipoDeInfoAfetada: {
      selected: {id: 'regra_de_calculo', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.regraDeCalculo')},
      loaded: [
        {id: 'empregado', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.empregados')},
        {id: 'regra_de_calculo', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.regraDeCalculo')},
        {id: 'local_de_trabalho', name: i18n.t('lockerRules.details.LockerRulesDetails.afetados.localDeTrabalho')}
      ]
    },
    idsAfetados: { selected: [] },
    tipoDeGatilho: {
      selected: {id: 'evento_travamento', name: i18n.t('lockerRules.details.State.tipoGatilho.travamentoIniciado')},
      loaded: [
        {id: 'dias_corridos', name: i18n.t('lockerRules.details.State.tipoGatilho.dia')},
        {id: 'evento_travamento', name: i18n.t('lockerRules.details.State.tipoGatilho.travamentoIniciado')}
      ]
    },
    diasDeTolerancia: 0,
    temPrazoDeTravamento: true,
    confirmarAutomaticamente: true,
    diaDoFechamento: 1,
    perfisResponsaveis: { selected: [] },
    carregando: false,
    listaDeRegras: [],
    carregandoAplicacao: false,
  }
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetarParaEstadoInicial(state, defaultState())
  },
  carregando (state, payload) {
    state.carregando = payload
  },
  resetAfetados (state) {
    state.idsAfetados = { selected: [] }
  },
  setarRegraDeTravamento (state, {...regraDeTravamento}) {
    state.id = regraDeTravamento.id
    state.nome = regraDeTravamento.nome
    state.ativo = regraDeTravamento.ativo
    state.codigo = regraDeTravamento.codigo
    state.tipoDeGatilho.selected = retornarTipoDeGatilho(regraDeTravamento.tipo_de_gatilho)
    state.tipoDeInfoAfetada.selected = retonarTipoDeInfoAfetada(regraDeTravamento.configuracao_de_aplicacao_da_regra.tipo_de_info_afetada)
    state.idsAfetados.selected = regraDeTravamento.configuracao_de_aplicacao_da_regra.ids_afetados
    state.diasDeTolerancia = regraDeTravamento.configuracao_de_gatilho.dias_de_tolerancia
    state.temPrazoDeTravamento = regraDeTravamento.configuracao_de_gatilho.tem_prazo_de_travamento
    state.confirmarAutomaticamente = regraDeTravamento.configuracao_de_gatilho.confirmar_automaticamente
    state.diaDoFechamento = regraDeTravamento.configuracao_de_gatilho.dia_do_fechamento
    state.perfisResponsaveis.selected = regraDeTravamento.configuracao_de_gatilho.perfis_responsaveis
    state.tipoDeEventoDeTravamento = regraDeTravamento.configuracao_de_gatilho.tipo_de_evento_de_travamento
  },
  setarListaDeRegrasDeTravamento (state, listaDeRegras) {
    let novaListaDeRegras = listaDeRegras.map(regra => formatarObjetoParaGuardarNoState(regra))
    state.listaDeRegras = novaListaDeRegras
  },
  carregandoAplicacao(state, payload) {
    state.carregandoAplicacao = payload
  },
}

const actions = {
  async carregarListaDeRegrasDeTravamento ({ commit }, listaDeRegras) {
    commit('setarListaDeRegrasDeTravamento', listaDeRegras)
  },

  async consultarRegraDeTravamento ({ commit }, regraId) {
    commit('carregando', true)
    const api = await API.regraDeTravamento.get({id: regraId})
    const infoRegraDeTravamento = api.data.success[0]
    commit('setarRegraDeTravamento', { id: regraId, ...infoRegraDeTravamento })
    commit('carregando', false)
  },

  async criarOuAtualizarRegraDeTravamento ({ state }) {
    let regraId = state.id
    let regraDeTravamento = formatarObjetoParaRequisicao(state)

    if (regraId) {
      try {
        const resultado = await API.regraDeTravamento.update({ id: regraId }, regraDeTravamento)
        swal({
          type: 'success',
          title: resultado.data.success || i18n.t('lockerRules.details.State.mensagemSucessoRegraTravamentoEditada'),
          text: resultado.data.obs || null
        })
        router.push('/regras-de-travamento/list')
      } catch (erro) {
        swal({
          type: 'error',
          title: i18n.t('lockerRules.details.LockerRulesDetails.totalAfetados.mensagensValidacao.titulo'),
          confirmButtonText: i18n.t('lockerRules.details.LockerRulesDetails.totalAfetados.mensagensValidacao.botaoVoltar'),
          text: retornarMensagemDeErro(erro)
        })
      }
    } else {
      try {
        const resultado = await API.regraDeTravamento.save(regraDeTravamento)
        swal({
          type: 'success',
          title: resultado.data.success || i18n.t('lockerRules.details.State.mensagemSucessoRegraTravamentoSalva'),
          text: resultado.data.obs || null
        })
        router.push('/regras-de-travamento/list')
      } catch (erro) {
        swal({
          type: 'error',
          title: i18n.t('lockerRules.details.LockerRulesDetails.totalAfetados.mensagensValidacao.titulo'),
          confirmButtonText: i18n.t('lockerRules.details.LockerRulesDetails.totalAfetados.mensagensValidacao.botaoVoltar'),
          text: retornarMensagemDeErro(erro)
        })
      }
    }
  },

  async ativarOuDesativarRegraDeTravamento (_, payload) {
    let acao = payload['acao']
    let regraId = payload['regraId']

    const novoEstado = {
      id: regraId,
      acao
    }

    try {
      const resultado = await API.atualizarRegraDeTravamento.patch({}, novoEstado)
      let mensagemPadrao = i18n.t('lockerRules.details.State.mensagemRegraAtivadaComSucesso')
      if (acao === 'desativar') {
        mensagemPadrao = i18n.t('lockerRules.details.State.mensagemRegraDesativadaComSucesso')
      }
      swal({
        type: 'success',
        title: resultado.data.success || mensagemPadrao,
        text: resultado.data.obs || null
      })
    } catch (erro) {
      let mensagemPadrao = i18n.t('lockerRules.details.State.erroTextoAtivarRegra')
      if (acao === 'desativar') {
        mensagemPadrao = i18n.t('lockerRules.details.State.erroTextoDesativarRegra')
      }
      swal({
        type: 'error',
        title: i18n.t('lockerRules.comuns.tituloErroGenerico'),
        text: retornarMensagemDeErro(erro, mensagemPadrao)
      })
    }
  },

  async deletarRegraDeTravamento (_, payload) {
    let regraId = payload['regraId']
    try {
      const resultado = await API.regraDeTravamento.delete({ id: regraId })
      swal({
        type: 'success',
        title: resultado.data.success || i18n.t('lockerRules.details.State.mensagemExcluirRegraSucesso'),
        text: resultado.data.obs || null
      })
    } catch {
      swal({
        type: 'error',
        title: i18n.t('lockerRules.details.State.erroTituloExcluirRegra'),
        text: i18n.t('lockerRules.details.State.erroTextoExcluirRegra')
      })
    }
  },

  async carregarPaginaDeUsuariosBloqueados(_, { page, perPage, allSearch }) {
    const configResp = await API.configuracaoEmailTravamento.get({})
    const { usuarios_bloqueados, role_groups_bloqueados, usuarios_desbloqueados_individualmente } = configResp.body || {}
  
    const desbloqueadosSet = new Set(usuarios_desbloqueados_individualmente || [])
    let usuarios = []
  
    if (usuarios_bloqueados?.length) {
      const lotesDeUsuarios = dividirEmLotes(usuarios_bloqueados, 100)
      const respostas = await Promise.all(
        lotesDeUsuarios.map(lote => API.informacoesDeUsuario.get({
          ids_dos_usuarios: JSON.stringify(lote),
          fields: JSON.stringify(['id', 'name', 'email'])
        }))
      )
      usuarios = respostas.flatMap(usersResp => usersResp.data || usersResp.body || [])
    }
  
    if (role_groups_bloqueados?.length) {
      const roleGroupsSet = new Set(role_groups_bloqueados)
      const usersResp = await API.user.get({
        fields: JSON.stringify(['id', 'name', 'email', 'role_group'])
      })
      const todos = usersResp.body?.success || []
      const usuariosDoPerfil = todos
        .filter(u => roleGroupsSet.has(obterIdDoPerfilDoUsuario(u)))
        .filter(u => !desbloqueadosSet.has(u.id))  // exclui quem foi desbloqueado individualmente
      usuarios = [...usuarios, ...usuariosDoPerfil]
    }
  
    const vistos = new Set()
    usuarios = usuarios.filter(u => {
      if (vistos.has(u.id)) return false
      vistos.add(u.id)
      return true
    })
  
    const termNome = allSearch?.nome?.toLowerCase() || ''
    const termEmail = allSearch?.email?.toLowerCase() || ''
    if (termNome) usuarios = usuarios.filter(u => u.name?.toLowerCase().includes(termNome))
    if (termEmail) usuarios = usuarios.filter(u => u.email?.toLowerCase().includes(termEmail))
  
    const totalItems = usuarios.length
    const totalPages = Math.ceil(totalItems / perPage) || 1
    const inicio = page * perPage
  
    return {
      items: usuarios.slice(inicio, inicio + perPage).map(u => ({ id: u.id, nome: u.name, email: u.email })),
      totalItems,
      totalPages
    }
  },

  async aplicarConfiguracao({ commit }, payload) {
    commit('carregandoAplicacao', true)
    try {
      const naoEnviarEmails = payload.acaoSelecionada === 'ativar'
      let totalAfetados = 0
  
      if (payload.modoSelecionado === 'usuario') {
        totalAfetados = payload.usuariosSelecionados.selected.length
        const usuariosIds = payload.usuariosSelecionados.selected.map(u => u.id)
      
        await API.configuracaoEmailTravamento.updateBatch({}, {
          usuarios_ids: usuariosIds,
          nao_enviar_emails: naoEnviarEmails
        })
      
        
        if (!naoEnviarEmails) {
          const configResp = await API.configuracaoEmailTravamento.get({})
          const { role_groups_bloqueados } = configResp.body || {}
      
          if (role_groups_bloqueados?.length) {
            const usuariosDesativadosSet = new Set(usuariosIds)
            const usersResp = await API.user.get({
              fields: JSON.stringify(['id', 'role_group'])
            })
            const todos = usersResp.body?.success || []
      
            const perfisParaDesativar = role_groups_bloqueados.filter(rgId => {
              const usuariosDoPerfil = todos
                .filter(u => obterIdDoPerfilDoUsuario(u) === rgId)
                .map(u => u.id)
              
              return usuariosDoPerfil.length > 0 && usuariosDoPerfil.every(id => usuariosDesativadosSet.has(id))
            })
      
            if (perfisParaDesativar.length) {
              await API.configuracaoEmailTravamento.updateBatch({}, {
                role_groups_ids: perfisParaDesativar,
                nao_enviar_emails: false,
                usuarios_dos_perfis: usuariosIds
              })
            }
          }
        }
      } else {
        const roleGroupsSet = new Set(payload.permissoesSelecionadas.selected.map(p => p.id))
        const usersResp = await API.user.get({
          fields: JSON.stringify(['id', 'role_group'])
        })
        const todos = usersResp.body?.success || []
        const usuariosDosPerfisSelecionados = todos
          .filter(u => roleGroupsSet.has(obterIdDoPerfilDoUsuario(u)))
          .map(u => u.id)
  
        totalAfetados = usuariosDosPerfisSelecionados.length
  
        await API.configuracaoEmailTravamento.updateBatch({}, {
          role_groups_ids: payload.permissoesSelecionadas.selected.map(p => p.id),
          nao_enviar_emails: naoEnviarEmails,
          usuarios_dos_perfis: usuariosDosPerfisSelecionados
        })

        const usuariosParaSincronizar = obterUsuariosParaSincronizarComBloqueioPorPerfil(
          usuariosDosPerfisSelecionados,
          naoEnviarEmails
        )

        if (usuariosParaSincronizar.length) {
          await API.configuracaoEmailTravamento.updateBatch({}, {
            usuarios_ids: usuariosParaSincronizar,
            nao_enviar_emails: naoEnviarEmails
          })
        }
      }
  
      swal({
        type: 'success',
        title: i18n.t('lockerRules.componentes.configuracaoDeEmails.sucesso.configuracaoAplicada', {
          total: totalAfetados,
          acao: naoEnviarEmails
            ? i18n.t('lockerRules.componentes.configuracaoDeEmails.sucesso.ativado')
            : i18n.t('lockerRules.componentes.configuracaoDeEmails.sucesso.desativado')
        })
      })
    } catch (erro) {
      swal({
        type: 'error',
        title: i18n.t('lockerRules.comuns.tituloErroGenerico'),
        text: retornarMensagemDeErro(erro, i18n.t('lockerRules.componentes.configuracaoDeEmails.erros.erroAplicar'))
      })
    } finally {
      commit('carregandoAplicacao', false)
    }
  },

  async desbloquearUsuario(_, usuario) {
    try {
      await API.configuracaoEmailTravamento.updateBatch({}, {
        usuarios_ids: [usuario.id],
        nao_enviar_emails: false
      })
      swal({
        type: 'success',
        title: i18n.t('lockerRules.componentes.configuracaoDeEmails.sucesso.usuarioDesbloqueado', {
          nome: usuario.nome
        })
      })
    } catch (erro) {
      swal({
        type: 'error',
        title: i18n.t('lockerRules.comuns.tituloErroGenerico'),
        text: retornarMensagemDeErro(erro, i18n.t('lockerRules.componentes.configuracaoDeEmails.erros.erroDesbloquear'))
      })
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
  actions
}
